module.exports = __webpack_public_path__ + "img/close.1408b6b4.svg";